import {
  About,
  Features,
  Footer,
  Hero,
  Navbar,
  Team,
} from "./components";

import vpPic from "./assets/vp_pic.png";

const App = () => (
  <>
    <Navbar />
    <main className="overflow-hidden bg-gray-900">
      <Hero />
      
      <section 
        id="about-section" 
        className="relative min-h-screen flex items-center justify-center"
        style={{
          backgroundImage: `url(${vpPic})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 1
        }}
      >
        <div 
          className="absolute inset-0" 
          style={{ 
            backgroundColor: '#0a192f', 
            opacity: 0.85 
          }}
        ></div>
        <div className="relative z-10 w-full">
          <About />
        </div>
      </section>
      
      <Features />
      
      <Team />
    </main>
    <Footer />
  </>
);

export default App;
